import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";

import {
  CHANGE_DATA_ARCHITECTURE,
  CHANGE_DATA_EQUIPMENT,
  CHANGE_DATA_FIREEQUIPMENT,
} from "./Word";

const reducerMap = {
  Architecture: CHANGE_DATA_ARCHITECTURE,
  Equipment: CHANGE_DATA_EQUIPMENT,
  FireEquipment: CHANGE_DATA_FIREEQUIPMENT,
};

const InputCheckBoxBase = React.memo(({ key_num, type }) => {
  const { b: bulding, page } = useParams();
  const dispatch = useDispatch();

  let value = useSelector((state) => state[type]?.[bulding]?.[page]?.[key_num]);

  if (value === "") value = false;

  const handleChange = () => {
    dispatch({
      type: reducerMap[type],
      payload: { [key_num]: !value },
      bulding,
      page,
    });
  };

  return <Checkbox checked={value} onChange={handleChange} />;
});

export const InputCheckBox = (props) => (
  <InputCheckBoxBase {...props} type="Architecture" />
);

export const InputCheckBoxEquip = (props) => (
  <InputCheckBoxBase {...props} type="Equipment" />
);

export const InputCheckBoxFireEquip = (props) => (
  <InputCheckBoxBase {...props} type="FireEquipment" />
);
